<template>
  <v-container
    fluid
    class="out-padding out-margin"
    style=" display: flex!important; align-items: flex-end;"
  >
    <v-row style="margin: 0px" class="out-padding out-margin" justify="center">
      <v-col
        class="out-padding out-margin"
        :cols="$vuetify.breakpoint.mobile ? 12 : 6"
      >
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const props = {
  col: {
    default: 6,
    type: Number,
  },
};

export default {
  methods: {},
  props: props,
};
</script>

<style scoped></style>
